import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { min, max } from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'Paginator',
  props: {
  currentIndex: {
    type: Number,
    required: true
  },
  numberOfElements: {
    type: Number,
    required: true
  },
  elementsPerPage: {
    type: Number,
    required: true
  },
  undeterminate: Boolean,
  disableNextPage: Boolean,
  alternateStyle: {
    type: Boolean,
    default: false
  }
},
  emits: ['go-to-page'],
  setup(__props, { emit }) {

const props = __props;

const label = 'common.navigation.of';





const page = ref(1); // TODO: If Vue 3.4 or above, to be replaced by defineModels

const pageField = computed(() => `width: max(${page.value.toString().length + 3}ch, 45px)`);

const currentPage = computed(() => Math.floor(props.currentIndex! / props.elementsPerPage!) + 1);

const numberOfPages = computed(() => Math.ceil(props.numberOfElements! / props.elementsPerPage!));

const isNextPageEnabled = computed(() => currentPage.value < numberOfPages.value);

const isPrevPageEnabled = computed(() => currentPage.value > 1);

function onPageChange() {
  page.value = max([page.value, 1])!;
  page.value = min([page.value, numberOfPages.value])!;

  if (currentPage.value !== page.value && page.value > 0) {
    emit('go-to-page', page.value);
  }
}

watch(
  currentPage,
  () => { page.value = currentPage.value; },
  { immediate: true }
);

watch(
  numberOfPages,
  onPageChange,
  { immediate: true }
);


return { __sfc: true,label, props, emit, page, pageField, currentPage, numberOfPages, isNextPageEnabled, isPrevPageEnabled, onPageChange, max }
}

})